module.exports = __webpack_public_path__ + "img/profile-picture-martijn-min.34196b8d.jpg";